<template>
  <div>
    <div class="row sits-sign-up">
      <div class="col-lg-12 col-md-12 col-12">
        <div class="form-group mb-4">
          <input
            class="form-control"
            type="text"
            autocomplete="off_fullName"
            placeholder=" "
            v-model="signup.fullName"
          />
          <label class="floatingLabel" for="fullName">Your full name</label>
          <div class="invalid-feedback" v-if="errors.fullName">
            {{ errors.fullName[0] }}
          </div>
        </div>
        <div class="form-group mb-4">
          <input
            class="form-control"
            type="text"
            autocomplete="off_dealerShipName"
            placeholder=" "
            v-model="signup.dealerShipName"
          />
          <label class="floatingLabel" for="dealerShipName"
            >Dealership name</label
          >
          <div class="invalid-feedback" v-if="errors.dealerShipName">
            {{ errors.dealerShipName[0] }}
          </div>
        </div>
        <div class="form-group mb-4">
          <input
            class="form-control"
            type="text"
            autocomplete="off_email"
            placeholder=" "
            v-model="signup.email"
          />
          <label class="floatingLabel" for="email">Email</label>
          <div class="invalid-feedback" v-if="errors.email">
            {{ errors.email[0] }}
          </div>
        </div>
        <div class="form-group mb-4">
          <input
            class="form-control"
            type="text"
            autocomplete="off_mobileNumber"
            placeholder=" "
            v-model="signup.mobileNumber"
          />
          <label class="floatingLabel" for="mobileNo">Mobile no</label>
          <div class="invalid-feedback" v-if="errors.mobileNumber">
            {{ errors.mobileNumber[0] }}
          </div>
        </div>

        <div>
          <button
            type="button"
            class="btn btn-primary float-right"
            @click="fnSignUp()"
          >
            Register
            <b-spinner small v-if="loading" class="mr-2"></b-spinner>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as authService from '../../../../services/auth.service'
import * as messageService from '../../../../services/message.service'
export default {
  name: 'SignUp1Form',
  props: ['formType'],
  computed: {},
  data: () => ({
    errors: {},
    signup: {},
    loading: false
  }),
  methods: {
    fnSignUp: async function () {
      try {
        this.loading = true
        const response = await authService.register(this.signup)

        if (response.data.status_code == 200) {
          this.$router.push({ name: 'auth.signUpWelcomeMsg' })
        }
        this.errors = {}
      } catch (error) {
        switch (error.response.status) {
          case 401:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Login',
              error.response.data.message
            )
            break
          case 403:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Login',
              error.response.data.message
            )
            break
          case 422:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Login',
              error.response.data.message
            )
            break
          case 500:
            messageService.fnSweetAlertErrorToast(
              'Login',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Login',
              'Something wrong, please try again!'
            )
            break
        }
      }

      this.loading = false
    }
  }
}
</script>
